export default "__VITE_ASSET__Cv9vyBfn__"